import { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import posthog from 'posthog-js'
import { Button, cn } from 'ui'

type Props = {
  inLayout?: boolean
}

const PageNotFound = ({ inLayout = false }: Props) => {
  const location = useLocation()

  // Surface client-side 404s in PostHog. Vercel rewrites every path to
  // index.html (see vercel.json), so an unknown route never returns a real
  // HTTP 404 — the SPA renders this catch-all instead, which otherwise looks
  // like an ordinary $pageview. Emit a dedicated event so 404s are queryable
  // and alertable without reverse-engineering the route table from pathnames.
  useEffect(() => {
    if (posthog) {
      posthog.capture('page_not_found', {
        $current_url: window.location.href,
        path: location.pathname,
      })
    }
  }, [location.pathname])

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center',
        `w-full gap-4 px-4 text-center ${inLayout ? 'h-full py-16' : 'h-screen'}`,
      )}
    >
      <img alt="" src="/404.png" className="w-[18rem]" />
      <h1 className="text-xl font-semibold text-foreground">
        We couldn&apos;t find that page
      </h1>
      <p className="text-base text-muted-foreground">
        The link may be out of date, or the address may have a typo.
      </p>
      <Button asChild>
        <Link to="/dashboard">Go to your dashboard</Link>
      </Button>
    </div>
  )
}

export default PageNotFound
